/**
 * environment.js
 * Accordion and tab interactions for environment fabric/material sections.
 * Matches vanilla ES6 class pattern used across the theme (navigation.js, configurator.js).
 */

class FabricTabs {
  constructor(item) {
    this.tabs   = [...item.querySelectorAll('[data-env-tab]')];
    this.panels = [...item.querySelectorAll('[data-env-panel]')];
    if (!this.tabs.length) return;
    this.tabs.forEach(tab =>
      tab.addEventListener('click', () => this.setTab(tab.dataset.envTab))
    );
  }

  setTab(key) {
    this.tabs.forEach(t =>
      t.classList.toggle('active', t.dataset.envTab === key)
    );
    this.panels.forEach(p =>
      p.classList.toggle('active', p.dataset.envPanel === key)
    );
  }
}

class EnvironmentAccordion {
  constructor(el) {
    this.items = [...el.querySelectorAll('[data-env-item]')];
    this.items.forEach(item => {
      const trigger = item.querySelector('[data-env-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', () => this.toggle(item));
      new FabricTabs(item);
    });
  }

  toggle(item) {
    const isOpen = item.classList.contains('is-open');
    this.items.forEach(i => i.classList.remove('is-open'));
    if (!isOpen) item.classList.add('is-open');
  }
}

function initEnvironmentAccordions() {
  document.querySelectorAll('[data-env-accordion]').forEach(el =>
    new EnvironmentAccordion(el)
  );
}

document.addEventListener('DOMContentLoaded', initEnvironmentAccordions);
window.addEventListener('shopify:section:load', initEnvironmentAccordions);
